import { render, staticRenderFns } from "./ProfilePreferences.vue?vue&type=template&id=9cbf149a&"
import script from "./ProfilePreferences.vue?vue&type=script&lang=js&"
export * from "./ProfilePreferences.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePreferences.vue?vue&type=style&index=0&id=9cbf149a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports